<template>
    <div>
        <div id="header-container" class="px-5 in-step">
            <img :src="`${publicPath}/img/gep/bg-header.svg`" class="img-header">
            <div class="pt-4 text-white mb-4">
                <h3 class="text-white">{{ $t('Add Beneficiary (Different Name)') }}</h3>
                <span class="fz-16 fw-400">Fill out the form to create new beneficiary</span>
            </div>

            <step-container
                :current_step="1"
                :step_list="stepList"
            ></step-container>
        </div>

        <b-container fluid class="mt-0 pb-5">
            <div id="body-container" class="px-4 pt-3">
                <b-row>
                    <b-col cols="12">
                        <h5 class="mb-4">{{ $t('Beneficiary Info') }}</h5>
                    </b-col>
                    <b-col cols="12" md="6">
                        <div class="form-group mb-3">
                            <label>{{ $t('Name') }} <span class="text-danger">*</span></label>
                            <input type="text" class="form-control" v-model="params.name" @keyup="onChange('name')"/>
                            <div v-if="error['name']" class="invalid-feedback d-block mb-3">
                                {{$t(error['name'])}}
                            </div>
                        </div>
                    </b-col>

                    <b-col cols="12" md="6">
                        <div class="form-group mb-3">
                            <label>{{ $t('Name - English') }} <span class="text-danger">*</span></label>
                            <input type="text" class="form-control" v-model="params.enName" @keyup="onChange('enName')"/>
                            <div v-if="error['enName']" class="invalid-feedback d-block mb-3">
                                {{$t(error['enName'])}}
                            </div>
                        </div>
                    </b-col>

                    <b-col cols="12" md="6">
                        <div class="form-group mb-3">
                            <label>{{ $t('Phone Number') }} <span class="text-danger">*</span></label>
                            <input type="text" class="form-control" v-model="params.phoneNum" @keyup="onChange('phoneNum')"/>
                            <div v-if="error['phoneNum']" class="invalid-feedback d-block mb-3">
                                {{$t(error['phoneNum'])}}
                            </div>
                        </div>
                    </b-col>

                    <b-col cols="12" md="6">
                        <div class="form-group mb-3">
                            <label>{{ $t('Country') }} <span class="text-danger">*</span></label>
                            <Select2 v-model="params.countryCode" :options="countryCodeOpt" @select="onSelectCountry($event)" :settings='{ escapeMarkup: doEscapeMarkup,placeholder:$t("Country")}' class="form-control"/>
                            <div v-if="error['countryCode']" class="invalid-feedback d-block mb-3">
                            {{$t(error['countryCode'])}}
                            </div>
                        </div>
                    </b-col>

                    <b-col cols="12" md="6">
                        <div class="form-group mb-3">
                            <label>{{ $t('Province') }} <span class="text-danger">*</span></label>
                            <Select2 v-model="params.province" :options="provinceOpt" @select="onSelectProvince($event)" :settings='{ escapeMarkup: doEscapeMarkup,placeholder:$t("Province")}' class="form-control"/>
                            <div v-if="error['province']" class="invalid-feedback d-block mb-3">
                                {{$t(error['province'])}}
                            </div>
                        </div>
                    </b-col>
                
                    <b-col cols="12" md="6">
                        <div class="form-group mb-3">
                            <label>{{ $t('City') }} <span class="text-danger">*</span></label>
                            <input type="text" v-model="params.city" name="city" value="" :placeholder="$t('City')" class="form-control" @keydown="onChange('city')" autocomplete="off">
                            <div v-if="error['city']" class="invalid-feedback d-block mb-3">
                                {{$t(error['city'])}}
                            </div>
                        </div>
                    </b-col>

                    <b-col cols="12" md="6">
                        <div class="form-group mb-3">
                            <label>{{ $t('Postal Code') }} <span class="text-danger">*</span></label>
                            <input type="text" class="form-control" v-model="params.zipCode" @keyup="onChange('zipCode')"/>
                            <div v-if="error['zipCode']" class="invalid-feedback d-block mb-3">
                                {{$t(error['zipCode'])}}
                            </div>
                        </div>
                    </b-col>

                    <b-col cols="12" md="6">
                        <div class="form-group mb-3">
                            <label>{{ $t('Address') }} <span class="text-danger">*</span></label>
                            <input type="text" class="form-control" v-model="params.address" @keyup="onChange('address')" @keypress="validateInput($event)"/>
                            <div v-if="error['address']" class="invalid-feedback d-block mb-3">
                                {{$t(error['address'])}}
                            </div>
                        </div>
                    </b-col>

                    
                </b-row>

                <b-row class="mb-5 mt-5">
                    <b-col cols="12" class="d-flex">
                        <button @click="$router.go(-1);" class="btn btn-previous d-block mr-auto">{{ $t('Previous') }}</button>
                        <button @click="doSubmit" class="btn btn-primary d-block">{{ $t('Next') }}</button>
                    </b-col>
                </b-row>
                
            </div>
        </b-container>
        <LoaderComponent v-if="isLoading"></LoaderComponent>
    </div>
</template>
<script>

import LoaderComponent from "@/components/LoaderComponent";
import Select2 from 'v-select2-component';
import CreateAccount from "@/services/CreateAccount";
import Common from "@/services/Common";
import Withdrawal from "@/services/Withdrawal";
import stepContainer from "@/components/CardManagement/stepContainer";

export default {
   name: 'add-partner',
   data() {
       return {
            publicPath :process.env.BASE_URL!='/'?process.env.BASE_URL:'',
            userNo:'',
            currentCountryCode:'',
            isLoading:false,
            optional:[],
            accountCcyOpt:[],
            countryCodeOpt:[],
            provinceOpt:[],
            paymentChannelTypeOpt:[
                {"value":"SWIFT","text":"SWIFT"},
                {"value":"LOCAL","text":"LOCAL"}
            ],
            currentCountry:'',
            accTypeOpt:[
                {"text":"Business","id":1},
                {"text":"Individual","id":2}
            ],
            stepList:["Beneficiary Info", "Bank Info", "Beneficiary Summary"],
            params:{
                name:'',
                enName:'',
                phoneNum:'',
                countryCode:'',
                province:'',
                city:'',
                address:'',
                zipCode:''
            },
            error:{
                name:'',
                enName:'',
                phoneNum:'',
                countryCode:'',
                province:'',
                city:'',
                address:'',
                zipCode:''
            }
       }
   },
   components: {
       LoaderComponent,
       Select2,
       stepContainer
   },
   methods:{
    validateInput(event) {
      const allowedChars = /^[a-zA-Z0-9 _-]$/;
      const char = String.fromCharCode(event.which);
      
      if (!allowedChars.test(char)) {
        event.preventDefault();
        return false;
      }
    },
    onChange(key){
        this.error[key]="";
    },
    getCountry(){
        let self = this;
        Common.countries().then(response => {
          if(response.status == 200 && response.data.success){
            const countries=response.data.data;
  
            for (let i = 0; i < countries.length; i++) {
              const flag = '<span class="fi fi-'+countries[i]['iso2'].toLowerCase()+'"></span>';  
              const country_name = "<span>"+this.$t(countries[i]['name'])+"\t\t\t"+"</span>";
              
              if(this.params.countryCode == countries[i]['iso2']){
                this.currentCountry = countries[i]['name'];
                this.currentCountryCode = countries[i]['iso3'];
              }
              
              self.countryCodeOpt.push({"id":countries[i]['iso2'],"text":flag+country_name,"name":countries[i]['name'],"iso3":countries[i]['iso3']});
            }
          }
        });
    },
    doEscapeMarkup(markup){
        return markup;
    },
    onSelectCountry({id,name,iso3}){
        let self = this;
        this.currentCountry = name;
        this.currentCountryCode = iso3;
        this.error.countryCode = '';
        this.getProvince(id);
    },
    getProvince(id){
        let self = this;
        Common.states({"country_code":id}).then(response => {
            if(response.status == 200 && response.data.success){
                const state = response.data.data;
                for (let i = 0; i < state.length; i++) {
                    self.provinceOpt.push({"id":state[i]['name'],"text":state[i]['name']});
                }
            }
        });
    },
    onSelectProvince({id,text}){
        var self = this;
        this.onChange('province');
        if(text){
        this.params.city="";
        }
    },
    onSelectType(){
        this.error.accType = '';
    },
    getSubAccount(){
        let self = this;
        CreateAccount.listSubAccount({
                start:0,
                length:-1,
                search:{value:self.userNo}
            }).then((response)=>{
                if (response.status == 200) {
                    if(response.data.data.length>0){
                        let sub_account = response.data.data[0];
                        self.accountCcyOpt = sub_account['currency'].split(",");
                    }
                }
            });
    },
    getUser(){
        let self = this;
        CreateAccount.list().then((response)=>{
            if (response.status == 200) {
                let account = response.data.data;
                if(account){
                    account.forEach(element => {
                        if(element.status == 2){
                            self.userNo = element.userNo;
                            self.getSubAccount();
                        }
                    });
                }
            }
        });
    },
    validate(){
        let success = true;
        let self = this;
        Object.keys(this.params).forEach(function(key) {
            if(!self.params[key]&& !self.optional.includes(key)){
                self.error[key]="can not be blank.";
                success = false;
            }
        });

        return success;
    },
    doSubmit(){
        let self = this;
        
        if(this.validate()){
            let add_partner = {
                name:this.params.name,
                enName:this.params.enName,
                phoneNum:this.params.phoneNum,
                countryCode:this.params.countryCode,
                countryCodeIso3:this.currentCountryCode,
                countryName:this.currentCountry,
                province:this.params.province,
                city:this.params.city,
                zipCode:this.params.zipCode,
                address:this.params.address
            };

            localStorage.setItem('add_partner', JSON.stringify(add_partner));
            
            this.$router.push({ 
                path: 'partner-bank-info'
            });
        }
    },
    getMessage: function (key) {
        return this.$t(key)
    },
    checkError(err){
        this.isLoading = false;
        const response = err.response;  
        console.log("===================");
        let self = this;
        if(response.status == 400){
            console.log(response.data);
            if(typeof response.data.message === 'string'){
                this.$swal({
                    icon: 'info',
                    html:response.data.message,
                    showConfirmButton: true,
                    confirmButtonText: self.getMessage('OK')
                });
            }
            else{
                if(response.data.message['errorMsg']){
                    this.$swal({
                        icon: 'info',
                        html:response.data.message['errorMsg'],
                        showConfirmButton: true,
                        confirmButtonText: self.getMessage('OK')
                    });
                }
                else{
                    let ret = [];
                    Object.keys(response.data.message).forEach((key) => {
                        ret.push(response.data.message[key][0]);
                    });

                    this.$swal({
                        icon: 'info',
                        html:ret.join("<br>"),
                        showConfirmButton: true,
                        confirmButtonText: self.getMessage('OK')
                    });
                }
            }
        }      
        else if(response.status == 401 && response.data.name == "Unauthorized"){
                localStorage.removeItem("token");
                localStorage.removeItem("member");
                localStorage.removeItem("isFirstTime");
                this.$router.push({ 
                    path: '/login', 
                });
        }
        else{
            if(localStorage.getItem("token")){
                var msg = (response.data)?response.data.message:err.message;
                this.$notify({
                    type: 'warn',
                    text: msg
                })
            }
        }
    }
   },
   mounted(){
    let self = this;
        this.$nextTick(() => {
            self.getUser();
            
            let add_partner = localStorage.getItem("add_partner");
            if(add_partner){
                add_partner = JSON.parse(add_partner);
                Object.keys(this.params).forEach(key => {
                    self.params[key] = add_partner[key];
                });
                this.getProvince(self.params.countryCode);
            }

            self.getCountry();
        });
   }
};
</script>
